import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useState } from "react";
import { BoardSelect } from "~/components/BoardSelect/BoardSelect";
import { useBoardSelectSearch } from "~/components/BoardSelect/useBoardSelectSearch";
import { usePrivateAddOnFeatures } from "~/hooks/usePrivateAddOnFeatures";
import { useCurrentWorkspace } from "~/providers/CurrentWorkspaceProvider";
export const PrivateBoardSelect = /*#__PURE__*/ memo((param)=>{
    let { children, getBoardDisabledMessage, getLibraryDisabledMessage, initialBoard, isBoardDisabled, isBoardSelected, isLibraryDisabled, isLibrarySelected, onCreateBoard, onSelectBoard, onSelectLibrary, shouldShowSubBoards } = param;
    const [search, setSearch] = useState("");
    const { libraries: librariesFlag } = usePrivateAddOnFeatures();
    const { currentWorkspace } = useCurrentWorkspace();
    const { boards, libraries } = useBoardSelectSearch({
        search,
        hasLibraries: librariesFlag,
        workspaceId: currentWorkspace === null || currentWorkspace === void 0 ? void 0 : currentWorkspace.id
    });
    return /*#__PURE__*/ _jsx(BoardSelect, {
        boards: boards,
        getBoardDisabledMessage: getBoardDisabledMessage,
        getLibraryDisabledMessage: getLibraryDisabledMessage,
        hasLibraries: librariesFlag,
        initialBoard: initialBoard,
        isBoardDisabled: isBoardDisabled,
        isBoardSelected: isBoardSelected,
        isLibraryDisabled: isLibraryDisabled,
        isLibrarySelected: isLibrarySelected,
        libraries: libraries,
        onCreateBoard: onCreateBoard,
        onSearchChange: setSearch,
        onSelectBoard: onSelectBoard,
        onSelectLibrary: onSelectLibrary,
        search: search,
        shouldShowSubBoards: shouldShowSubBoards,
        children: children
    });
});
PrivateBoardSelect.displayName = "PrivateBoardSelect";
